/**************************************************
 * Nombre:       Tarjeta_Educacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {COLORTEXTO} from "../../Constantes";


const Tarjeta_Educacion = ({item}) => {


    return (
        <Grid

            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                p: 4,
                borderBottom: 1,
                borderColor: COLORTEXTO + 90
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Typography sx={{fontSize: 24, fontWeight: 600}}>{item.nombre}</Typography>
            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                <Typography>{item.descripcion}</Typography>
            </Grid>


        </Grid>
    )

}
export default Tarjeta_Educacion